<template>
    <div class="orderList">
        <div v-for="dateGroup in groupedOrders" :key="dateGroup.date">
            <OrderDateGroup v-bind="dateGroup" />
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import OrderDateGroup from "./OrderDateGroup.vue";
import { parseApiCalendarDate } from "@/lib/HelperDate";
import { groupOrdersByDate } from "@/lib/HelperFns";

export default defineComponent({
    name: 'ListOfOrders',
    components: {
        OrderDateGroup,
    },
    props: {
        orders: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        sortedOrders() {
            return [...this.orders].sort((a, b) => {
                if (a.isClosed !== b.isClosed) {
                    return a.isClosed ? 1 : -1;
                }
                const aDt = parseApiCalendarDate(a.createdAt);
                const bDt = parseApiCalendarDate(b.createdAt);
                const aMs = aDt?.toMillis() ?? 0;
                const bMs = bDt?.toMillis() ?? 0;
                return bMs - aMs;
            });
        },
        groupedOrders() {
            return groupOrdersByDate(this.sortedOrders, 'createdAt');
        },
    },
})
</script>

<style>
</style>
